import React, { useEffect, useState, useContext } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import {
  ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE, DEFINED_TYPE_LINKS,
  PROFILE,
  SEARCH_AGENT_FILTER,
  SEARCH_TYPE,
} from '../../config/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import * as agentResourceApi from 'api/agentResources';
import * as searchApi from 'api/search';
import { useHistory } from 'react-router-dom';
import FormDialog from 'components/SearchFormDialog';
import { Col, Row } from 'antd';
import { getTextWebPages } from '../../api/textWebPage';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../utils/utils';
import { getAllAreaByAgent } from '../../api/agentResources';
import { AppContext } from '../../context/AppContext';


const styleWrapInline = {
  display: 'inline-block',
};

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

const styleItems = {
  padding: "4px 10px 0 10px"
}

const styleListItem2 = {
  padding: "0 0 4px 0"
}

function SearchAgent(props) {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [photoStatus, setPhotoStatus] = useState('');
  const [province, setProvince] = useState('');
  const [area, setArea] = useState('');
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [ageFrom, setAgeFrom] = useState('');
  const [ageTo, setAgeTo] = useState('');
  const [listArea, setListArea] = useState([]);
  // const { data: agentResource } = useQuery(['agentResource'], () => agentResourceApi.getAllResource());
  const  agentResource  = props.agentResource;
  const listStateAgent  = appContext.listStateAgent;
  const [listAgentOptions, setListAgentOptions] = useState([])
  const stickyContent = props?.textWebPage || '';


  useEffect(() => {
    setListAgentOptions(listStateAgent.filter((state) => !!state.label))
  },[listStateAgent])

  useEffect(() => {
    const fetchAreaByAgent = async (userState) => {
      const { data: listAreaData } = await getAllAreaByAgent(userState);
      setListArea(listAreaData);
    };
    if (province) {
      fetchAreaByAgent(province);
    }
  }, [province]);

  useEffect(() => {
    const fetchLocalStorage = async () => {
      const dataRaw = await getLocalStorage(SEARCH_AGENT_FILTER);
      if (dataRaw) {
        try {
          const data = JSON.parse(dataRaw);
          if (data?.avatar) {
            setPhotoStatus(data?.avatar);
          }
          if (data?.profiles) {
            setValues(data?.profiles);
          }
          if (data?.states) {
            setProvince(data?.states);
          }
          if (data?.area) {
            setArea(data?.area);
          }
        } catch (e) {
          // Todo
        }
      }
    };

    fetchLocalStorage();
  }, []);

  let displayAgeList = () => {
    let list = [];
    for (let i = 18; i <= 100; i++) {
      list.push(i);
    }
    return list;
  };

  const handleClearSearch = async () => {
    setPhotoStatus(null);
    setProvince(null);
    setAgeFrom(null);
    setAgeTo(null);
    setArea(null);
    setValues({});
    await removeLocalStorage(SEARCH_AGENT_FILTER);
  };

  const handleSearch = async () => {
    setLoading(true);
    const data = {
      avatar: !photoStatus ? null : photoStatus,
      profiles: { ...values },
      states: !province ? null : province,
      area: !area ? null : area,
    };

    await setLocalStorage(SEARCH_AGENT_FILTER, JSON.stringify(data));

    try {
      const { data: agentSearchList, message } = await searchApi.searchAgent(data);
      queryClient.setQueryData('agentSearchList', agentSearchList);
      queryClient.setQueryData('agentSearchListMessage', message);
      history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/search-agent-result` });
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  };

  const handleOnchange = (value, key) => {
    setValues({ ...values, [key]: value });
  };

  const showProfile = (list, data) => {
    if (data) {
      if (Array.isArray(data)) {
        let result = '';
        data.map((item) => {
          list.forEach(profile => {
            if (profile.value === item) {
              result += `<span class="d-symbol-search">${profile.label}</span>`;
            }
          });
        });

        return result;
      } else {
        return list.find((item) => item.value === data)?.label;
      }
    }

    // return null;
  };

  const handleProvince = (e) => {
    setProvince(e)
    setArea('')
  }

  const renderSearchBox = () => {
    // List Group Resource Profile
    const profileParent = {};

    const resourceChildren = agentResource?.data.reduce((accumulator, currentItem) => {
      const keyProfile = currentItem['profile'];
      // handle Profile Parent
      if (currentItem.value === PROFILE.ROOT) {
        // check Profile Parent is exist in List Group Resource Profile
        if (!profileParent[keyProfile]) {
          profileParent[keyProfile] = {};
        }
        // Title of Resource Item
        profileParent[keyProfile]['title'] = currentItem.label;
        // Profile Order to specify the order displayed on the Profile Screen
        profileParent[keyProfile]['searchOrder'] = currentItem.searchOrder;
        profileParent[keyProfile]['searchType'] = currentItem.searchType;
      }
      // Handle Profile Children
      if (currentItem.value !== PROFILE.ROOT) {
        // Group By Profile Parrent
        if (!accumulator[keyProfile]) {
          accumulator[keyProfile] = [];
        }
        accumulator[keyProfile].push(currentItem);
      }
      return accumulator;
    }, []);

    //Display List Profile Group and sorting by profileOrder that is used in Profile screen
    return Object.keys(profileParent)
      .sort((a, b) => profileParent[a].searchOrder - profileParent[b].searchOrder)
      .map((profile, key) => {
        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.DROPDOWN) {
          return (
            <div key={key}>
              <ListItem className={`${styles.lableSelect} font-2`}
                        style={{ ...styleItems }}>{profileParent[profile]?.title}</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search">
                  <div className="d-text-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namelabel={profileParent[profile]?.title}
                      namevalue={values[profile] || []}
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile)}
                      type={'single'}
                      text={showProfile(resourceChildren[profile], values[profile])}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          );
        }

        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.CHECKBOX) {
          return (
            <Row style={{ marginTop: 3 }} key={key}>
              <Col xs={12} style={{ padding: '2px 0 0 0' }}>
                <span style={{ ...styleWrap, ...styleItems }} className={`${styles.lableSelect} font-2`}>
                  {profileParent[profile]?.title}
                </span>
              </Col>
              <Col xs={12} style={{ padding: '0 0 3px' }}>
                <div className="d-item-box-search-text">
                  <FormDialog
                    namevalue={values[profile] || []}
                    namelabel={profileParent[profile]?.title}
                    resource={resourceChildren[profile]}
                    onchangeData={(e) => handleOnchange(e, profile)}
                    type={'multiple'}
                    text={showProfile(resourceChildren[profile], values[profile])}
                  />
                </div>
              </Col>
            </Row>
          );
        }

        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.RANGE) {
          return (
            <div key={key}>
              <ListItem className={`${styles.lableSelect} font-2`}
                        style={{ ...styleItems }}>{profileParent[profile]?.title}</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search d-flex justify-content-center">
                  <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_from']}
                      namelabel={profileParent[profile]?.title}
                      nametext="photo"
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile + '_from')}
                      text={resourceChildren[profile].find(e => e.value == values[profile + '_from'])?.label}
                    />
                  </div>
                  <div className="d-symbol-range">~</div>
                  <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_to']}
                      namelabel={profileParent[profile]?.title}
                      nametext="photo"
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile + '_to')}
                      text={resourceChildren[profile].find(e => e.value == values[profile + '_to'])?.label}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          );
        }
      });
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={styles.searchScreen}>
        {loading ? (
          <div className={styles.loading}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div>
            <div>
              <div className={styles.topNavContainer}>
                <TopNav name={'会社/店舗検索'} hasLogo={true} hasHamburger={true} />
              </div>
              <div className={`${styles.listSelect} d-search-agent-wrapper`}>
                <List component="nav" style={{paddingTop: 0}} className="d-search-box">
                  {stickyContent && (
                    <div className="d-wrapper-header-section d-wrapper-header-padding box-sticky-content">
                      <div className={'d-info-text font-3'}
                           dangerouslySetInnerHTML={{ __html: stickyContent }}></div>
                    </div>
                  )}

                  {/*<div className={`${!!(stickyContent && stickyContent.length) ? 'd-sticky-content-has' : 'd-sticky-content-none'}`}>*/}
                  {/*  <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>写真</ListItem>*/}
                  {/*  <ListItem style={{ ...styleListItem2 }}>*/}
                  {/*    <div className="d-flex justify-content-center d-item-box-search-text">*/}
                  {/*      <div onClick={() => setPhotoStatus(null)}*/}
                  {/*           className={`${styles.btnItemSearch} w-100 mr-10 ${!photoStatus ? 'bg-main-search' : 'bg-main-search-none'}`}>*/}
                  {/*        <div className="">全て</div>*/}
                  {/*      </div>*/}
                  {/*      <div onClick={() => setPhotoStatus(1)}*/}
                  {/*           className={`${styles.btnItemSearch} w-100 mr-10 ${photoStatus === 1 ? 'bg-main-search' : 'bg-main-search-none'}`}>*/}
                  {/*        <div className="">写真なし</div>*/}
                  {/*      </div>*/}
                  {/*      <div onClick={() => setPhotoStatus(2)}*/}
                  {/*           className={`${styles.btnItemSearch} w-100 ${photoStatus === 2 ? 'bg-main-search' : 'bg-main-search-none'}`}>*/}
                  {/*        <div className="">写真あり</div>*/}
                  {/*      </div>*/}
                  {/*    </div>*/}
                  {/*  </ListItem>*/}
                  {/*</div>*/}
                  {/*<div>*/}
                  {/*  <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>年齢</ListItem>*/}
                  {/*  <ListItem style={{ ...styleListItem2 }}>*/}
                  {/*    <div className="d-item-box-search d-flex justify-content-center">*/}
                  {/*      <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>*/}
                  {/*        <FormDialog*/}
                  {/*          namevalue={ageFrom}*/}
                  {/*          namelabel={'年齢'}*/}
                  {/*          nametext="agefrom"*/}
                  {/*          resource={displayAgeList()}*/}
                  {/*          onchangeData={(e) => setAgeFrom(e)}*/}
                  {/*          text={ ageFrom }*/}
                  {/*        />*/}
                  {/*      </div>*/}
                  {/*      <div className="d-symbol-range">~</div>*/}
                  {/*      <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>*/}
                  {/*        <FormDialog*/}
                  {/*          namevalue={ageTo}*/}
                  {/*          namelabel={'年齢'}*/}
                  {/*          nametext="ageto"*/}
                  {/*          resource={displayAgeList()}*/}
                  {/*          onchangeData={(e) => setAgeTo(e)}*/}
                  {/*          text={ ageTo }*/}
                  {/*        />*/}
                  {/*      </div>*/}
                  {/*    </div>*/}
                  {/*  </ListItem>*/}
                  {/*</div>*/}

                  <div>
                    <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>都道府県</ListItem>
                    <ListItem style={{ ...styleListItem2 }}>
                      <div className="d-item-box-search">
                        <div className="d-text-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                          <FormDialog
                            namevalue={province}
                            namelabel={'都道府県'}
                            nametext="state"
                            resource={listAgentOptions}
                            onchangeData={(e) => handleProvince(e)}
                            text={ listAgentOptions.find((e) => e.id == province)?.label }
                          />
                        </div>
                      </div>
                    </ListItem>
                  </div>

                  <div>
                    <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>エリア検索</ListItem>
                    <ListItem style={{ ...styleListItem2 }}>
                      <div className="d-item-box-search">
                        <div className="d-text-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                          <FormDialog
                            namevalue={area}
                            namelabel={'エリア検索'}
                            nametext="area"
                            resource={listArea}
                            onchangeData={(e) => setArea(e)}
                            text={ listArea.find((e) => e.id == area)?.label }
                          />
                        </div>
                      </div>
                    </ListItem>
                  </div>
                  {renderSearchBox()}
                  <br />
                </List>

                <List>
                  <ListItem alignItems="flex-start" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        position: 'fixed',
                        bottom: 56,
                        margin: 'auto',
                        width: '100%',
                        padding: '8px 0',
                        maxWidth: '560px',
                      }}
                    >
                      <Button className="btn btn-main" variant="contained" onClick={handleSearch}>
                        <span >検索する</span>
                      </Button>
                      <Button className="btn btn-sub" variant="contained" onClick={handleClearSearch}>
                        <span >クリア</span>
                      </Button>
                    </div>
                  </ListItem>
                </List>
              </div>
              <BottomNav />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


SearchAgent.getInitialProps = async ({
                                        req, res, match, history, location, ...ctx
                                      }) => {
  let textWebPages = [];
  try {
    let result = await getTextWebPages();
    textWebPages = result?.data || [];
  } catch (e) {
    textWebPages = [];
  }

  const findBlogMyEdit = textWebPages?.data?.find(ele => ele.link === DEFINED_TYPE_LINKS.SEARCH_AGENT && ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE.includes(DEFINED_TYPE_LINKS.SEARCH_AGENT));

  return { textWebPage: findBlogMyEdit?.content || '' };
};

export default SearchAgent;
